import {useRouter} from 'next/router'
import {memo, useCallback} from 'react'

import '@financial/mss-validator/dist/index.css'
import {MssChecker as PieMssChecker, MSS_CODE} from '@financial/mss-validator'

import {isLocalProfile} from '$share/utils/env'

import type {ReactNode} from 'react'

/**
 * @see https://yobi.navercorp.com/NaverCert/posts/162
 */
const CHECKING_CODE = MSS_CODE.애플리케이션변조 + MSS_CODE.버전

const MssChecker = memo(function MSSChecker({children}: {children: ReactNode}) {
    const {pathname} = useRouter()

    const checkMss = useCallback(async () => {
        if (pathname.includes('/playground') || isLocalProfile) {
            return false
        }
        return true
    }, [pathname])

    return (
        <PieMssChecker code={CHECKING_CODE} disableCheck={!checkMss()}>
            {children}
        </PieMssChecker>
    )
})

export default MssChecker
